import { pick } from 'lodash';
const POST_DRAFT_FIELDS = [
    // Settings
    'categoryIds',
    'coverImage',
    'firstPublishedDate',
    'seoSlug',
    'seoTitle',
    'seoDescription',
    'isFeatured',
    'ownerSiteMemberId',
    'excerpt',
    'canonicalUrl',
    'isCommentsDisabled',
    // RCE Fields
    'title',
    'content',
];
/** @deprecated legacy */
export function pickDraftProps(post) {
    return pick(post, POST_DRAFT_FIELDS);
}
//# sourceMappingURL=pick-draft-post.js.map